// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"461":"0ff12bc9","715":"73ff180c"}[chunkId] + ".chunk.js";
};